import { compose, bindActionCreators } from 'redux';

import { connect } from 'react-redux';

import routeDependencies from 'utilities/routeDependencies';
import { loadable } from 'modules/layout';

import { selectPartnersFetching } from '../services/selectors';
import { partnersRequest } from '../services/actions';

import PartnersPage from '../components/PartnersPage';

export default compose(
    connect(
        state => ({
            showLoader: selectPartnersFetching(state),
        }),
        dispatch => ({
            read: bindActionCreators(partnersRequest, dispatch),
        }),
    ),
    routeDependencies(),
    loadable,
)(PartnersPage);
